import styled from 'styled-components';

export const Circle = styled.div`
   width: 30px;
   height: 30px;
   border-radius: 15px;
   border: 2px solid #04D361;
`;

export const StrongText = styled.strong`
  font-size: 16px;
`;

export const SpanText = styled.span`
  color: '#737380';
`;